import React, { useState, useEffect } from "react";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { ContextProvider } from "../../Context";
import styles from "./Dashboard.module.css";
import { RemoveLocalStorage } from "../../LocalStorage/LocalStorage";
import { useNavigate } from "react-router-dom";
import Logo from "./Image/Logo.svg";
import { GetLocalStorage } from "../../LocalStorage/LocalStorage";
import { UserBgFormatting } from "../../ProfileImageModule";
export const SideBar = ({ fullname, userId, BvnVerify, NinVerify }) => {
  const Data = GetLocalStorage(); 
  const {
    setToggleSideBar,
    isDarkMode,
    handleClickOutside,
    customerDetail,
   progressTaskBarResponse

  } = useContext(ContextProvider);

  const { full_name, id } = customerDetail;

  const navigate = useNavigate();
  const RemoveLocalStorageKeys = () => {
    RemoveLocalStorage();
    const navigateLogin = () => navigate("/Login", { replace: true });
    navigateLogin();
    if (navigateLogin) {
      window.location.reload();
    }
  };
  const [dropDownOpen, setDropDownOpen] = useState({
    dropdown1: false,
    dropdown2: false,
    dropdown3: false,
    dropdown4: false,
    dropdown5: false,
    dropdown6: false,
  });

  const dropHandler = (dropdownName) => {
    setDropDownOpen((prevState) => ({
      dropdown1: dropdownName === "dropdown1" ? !prevState.dropdown1 : false,
      dropdown2: dropdownName === "dropdown2" ? !prevState.dropdown2 : false,
      dropdown3: dropdownName === "dropdown3" ? !prevState.dropdown3 : false,
      dropdown4: dropdownName === "dropdown4" ? !prevState.dropdown4 : false,
      dropdown5: dropdownName === "dropdown5" ? !prevState.dropdown5 : false,
      dropdown6: dropdownName === "dropdown6" ? !prevState.dropdown6 : false,
    }));
  };
  const UserIcon = localStorage.getItem("UserIcon") ? 
  localStorage.getItem("UserIcon") : "";

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  })
  const UserData = Data?.aremxyUsername?.toString();



const bgUsername = UserBgFormatting(UserData);
  return (
      <div
      className={`bvnQuery fixed overflow-auto ${
        isDarkMode ? "bg-[#000] border" : " bg-[#04177f]"
      } flex flex-col  justify-between  leading-normal text-white 
        w-[50%] rounded-tr-[11.17px] rounded-br-[11.17px] md:w-[178px]
        md:rounded-tr-[18px] md:rounded-br-[18px] h-[100%]
      lg:w-[20%] lg:rounded-br-[32px] lg:rounded-tr-[32px] lg:h-[100vh]`}>
      {/* =======Nav Bar========= */}
     <div
          className={`border-b-[0.3px]  ${
            isDarkMode ? "bg-[#000]" : "bg-[#04177f]"
          } `}
        >
          <div
            className={` ${
              isDarkMode
                ? "border-b-[0.3px]"
                : "border-b-[0.3px] border-b-[#fff]"
            } flex w-[100%] justify-between lg:h-[5.7rem] h-[4.75rem]
            items-center px-[10px] md:gap-[55px] `}
            // h-[13.97px] lg:py-[15%] py-[13%]
          >
            <img
              className="w-[59px] h-[30.23px] md:h-[10px] md:w-[67px] 
              lg:w-[125px] lg:h-[25px]"
              src={Logo}
              alt="Logo"
            />
            <div   onClick={() => setToggleSideBar(false)}
             className={`
            cursor-pointer w-[30px] h-[30px] md:h-[30.9px] 
              md:w-[30.9px] lg:h-[52px] lg:w-[52px]`}>
            <img
              className="w-full h-full "
              src="./Images/dashboardImages/menumenu.png"
              alt="Menu"
            />
            </div>
          </div>

          <div className="pl-[5px] pt-[5%] ">
            {/* ======Profile picture and name======== */}
            <div className="sticky top-0">
              
              <div className="flex gap-[5px] md:gap-[5px] justify-left
               items-center ">
                
                <div className={`${bgUsername}  bg-opacity-10`}>
                <img
                  className="w-[20.97px] h-[20.97px] md:w-[30px] md:h-[30px] lg:w-[40px] lg:h-[40px]"
                  src={UserIcon}
                  alt="DP"
                />

                
           
                </div>
                <div className="flex flex-col gap-[3px] justify-center mt-[4%]">
                  <div className="flex gap-0.5 items-center">
                  <p className={`text-[9px] w-[30%] font-bold  md:text-[14px]
                   text-left  lg:text-[14px] ${progressTaskBarResponse?.data?.data?.beta === true ? "lg:w-[40%] w-[40%]" : "w-full"}`}>
                    {full_name ? full_name : fullname}
                     
                  </p>
              {progressTaskBarResponse?.data?.data?.beta === true && (
                <span className="text-[11px] md:text-[12px]  text-[#7109d3] text-center  w-[60px]
                rounded-[5px] px-0.5 py-[3px] bg-[#f5ecfd]  leading-[14px] 
                lg:leading-[15px] lg:py-[5px]   lg:w-[80px] font-bold">
                  Beta
                </span>
              )}
                  </div>
                  <p className="text-[8px] font-semibold md:text-[14px] lg:text-[14px] ">
                    UID: {id ? id : userId}
                  </p>
                  <div className="flex gap-[3px] lg:gap-[5px]">
                    <div
                      className={`px-[4px] py-[1px] font-[600] lg:font-[700] text-[10px]
                      md:text-[10px] lg:text-[12px] rounded-[2px] ${
                        BvnVerify === "true" || NinVerify === "true"
                          ? "text-white bg-green-500"
                          : "text-red-600"
                      }`}
                    >
                      {BvnVerify === "true" || NinVerify === "true"
                        ? "Verified"
                        : "UnVerified"}
                    </div>
                    <div
                      className=" px-[4px] py-[1px] bg-[#FFC589] font-[600] lg:font-[700]
                       text-[10px] text-black md:text-[10px] lg:text-[12px] rounded-[2px]"
                    >
                      {/* KYCed */}
                Regular
                    </div>
                  </div>
                </div>
               
              </div>
            </div>
          </div>

          {/* ======Dashboard nav======= */}
         <div className="flex px-[10px] w-[100%] my-[20px] cursor-pointer">
            <div
            onClick={()=> {
              navigate("/dashboard")
            }}
             className={`${styles.dashboard}  gap-[10px]  px-[10px] py-[16px]  rounded-[10px] `}>
              <img
                className="w-[15.38px] h-[15.38px] md:w-[13px] md:h-[13px] 
                lg:h-[24px] lg:w-[24px]"
                src="./Images/dashboardImages/dashboardimg.png"
                alt="3squares"
              />
              <p className=" text-[12px]  font-semibold md:text-[14px] lg:text-[14px] ">
                Dashboard
              </p>
            </div>
          </div>
        </div>

        <div className=" flex flex-col">
          <div className=" mt-[9%] px-[8%] flex flex-col gap-[10px] ">
            {/* ========COLLECTIONS========= */}
            <div>
              <p
                className={`${styles.sidebartxt} text-[7px] lg:text-[14px] font-extrabold`}
              >
                COLLECTIONS
              </p>

              <div
                className={`${styles.sidebartxt} flex flex-col gap-[10px] text-[8px] font-semibold ml-[%] my-[7%] lg:text-[13px] lg:gap-[15px]`}
              >
                <Link
                  to={`/wallet`}
                  className="flex gap-[3.4px] items-center cursor-pointer lg:gap-[11px]"
                >
                  <img
                    className="w-[8.3px] h-[8.3px] md:w-[13.75px] md:h-[13.75px] lg:h-[24px] lg:w-[24px]"
                    src="./Images/dashboardImages/wallet.png"
                    alt="icon"
                  />
                  <p>Wallet</p>
                </Link>
                <Link to="/top-up">
                  <div className="flex gap-[3.4px] items-center cursor-pointer lg:gap-[11px]">
                    <img
                      className="w-[8.3px] h-[8.3px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                      src="./Images/dashboardImages/topup.png"
                      alt="icon"
                    />
                    <p>Top Up</p>
                  </div>
                </Link>
                <Link to="/money-transfer">
                  <div className="flex gap-[3.4px] items-center cursor-pointer lg:gap-[11px]">
                    <img
                      className="w-[8.3px] h-[8.3px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                      src="./Images/dashboardImages/transfer.png"
                      alt="icon"
                    />
                    <p>Transfer</p>
                  </div>
                </Link>
                <div
                  onClick={() => dropHandler("dropdown1")}
                  className="flex justify-between items-center"
                >
                  <Link to="/TransactionPage">
                    <div className="flex gap-[3.4px] items-center cursor-pointer lg:gap-[11px]">
                      <img
                        className="w-[8.3px] h-[8.3px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                        src="./Images/dashboardImages/transaction.png"
                        alt="icon"
                      />
                      <p>Transaction</p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>

            {/* =========PRODUCTS======== */}
            <div>
              <p
                className={`${styles.sidebartxt} text-[7px] lg:text-[14px] font-extrabold`}
              >
                PRODUCTS
              </p>

              <div
                className={`${styles.sidebartxt} flex flex-col gap-[10px] text-[8px] font-semibold ml-[%] my-[7%] lg:text-[13px] lg:gap-[15px]`}
              >
                <div
                  onClick={() => dropHandler("dropdown2")}
                  className="flex justify-between gap-[3.4px]"
                >
                  <div className="flex gap-[3.4px] items-center cursor-pointer lg:gap-[11px]">
                    <img
                      className="w-[8.3px] h-[8.3px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                      src="./Images/dashboardImages/telecom.png"
                      alt="icon"
                    />
                    <p>Telecom</p>
                  </div>
                  {!dropDownOpen.dropdown2 ? (
                    <img
                      className="h-[8.3px] w-[8.3px] lg:w-[24px] lg:h-[24px]"
                      src="./Images/dashboardImages/arrow-down.png"
                      alt="dropdown"
                    />
                  ) : (
                    <img
                      className="h-[8.3px] w-[8.3px] lg:w-[24px] lg:h-[24px]"
                      src="./Images/dashboardImages/arrow-up.png"
                      alt="dropup"
                    />
                  )}
                </div>
                {dropDownOpen.dropdown2 && (
                  <ul className=" mt-[-5px] rounded-[2.5px] gap-2 flex flex-col py- 1 bg-[#f2faff10] w-[100px] md:top-[36.5%] md:w-[100%] lg:w-[220px] lg:rounded-[6px] lg:top-[36.5%]">
                    <li className="flex gap-[5%] hover:underline text-[#fff] pt-1 pb-1 font-medium md:text-[11px] lg:pt-[6%] lg:pb-[6%] lg:pl-[%] lg:text-[14px] ">
                      <img
                        className="w-[8.5px] h-[8.5px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                        src="./Images/dashboardImages/sideArrow.png"
                        alt="/"
                      />
                      <Link to={"/airtime-topup"}>Airtime Top-up</Link>
                    </li>

                    <Link to="/data-top-up">
                      <li className="flex gap-[5%] hover:underline text-[#fff] pt-1 pb-1 font-medium md:text-[11px] lg:pt-[6%] lg:pb-[6%] lg:pl-[%] lg:text-[14px] ">
                        <img
                          className="w-[8.5px] h-[8.5px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                          src="./Images/dashboardImages/sideArrow.png"
                          alt="/"
                        />
                        <div>Data Top-up</div>
                      </li>
                    </Link>
                    <Link to="/EducationPins">
                      <li className="flex gap-[5%] hover:underline text-[#fff] pt-1 pb-1  font-medium md:text-[11px] lg:pt-[6%] lg:pb-[6%] lg:pl-[%] lg:text-[14px] ">
                        <img
                          className="w-[8.5px] h-[8.5px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                          src="./Images/dashboardImages/sideArrow.png"
                          alt="/"
                        />
                        <div>Education pins</div>
                      </li>
                    </Link>
                    <Link to="/TvSubscription">
                      <li className="flex gap-[5%] hover:underline text-[#fff] pt-1 pb-1 font-medium md:text-[11px] lg:pt-[6%] lg:pb-[6%] lg:pl-[%] lg:text-[14px] ">
                        <img
                          className="w-[8.5px] h-[8.5px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                          src="./Images/dashboardImages/sideArrow.png"
                          alt="/"
                        />
                        <div>Tv Subscription</div>
                      </li>
                    </Link>
                    <Link to="/electricity-subscription">
                      <li className="flex gap-[5%] hover:underline text-#fff] pt-1 pb-1 font-medium md:text-[11px] lg:pt-[6%] lg:pb-[6%] lg:pl-[%] lg:text-[14px] ">
                        <img
                          className="w-[8.5px] h-[8.5px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                          src="./Images/dashboardImages/sideArrow.png"
                          alt="/"
                        />
                        <div>Electricity Bills</div>
                      </li>
                    </Link>
                    <Link to="/airtime-conversion">
                      <li className="flex gap-[5%] hover:underline text-[#fff] pt-1 pb-1 font-medium md:text-[11px] lg:pt-[6%] lg:pb-[6%] lg:pl-[%] lg:text-[14px] ">
                        <img
                          className="w-[8.5px] h-[8.5px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                          src="./Images/dashboardImages/sideArrow.png"
                          alt="/"
                        />
                        <div>Airtime Conversion</div>
                      </li>
                    </Link>
                    <li className="flex gap-[5%] hover:underline text-[#fff] pt-1 pb-1 font-medium md:text-[11px] lg:pt-[6%] lg:pb-[6%] lg:pl-[%] lg:text-[14px] ">
                      <img
                        className="w-[8.5px] h-[8.5px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                        src="./Images/dashboardImages/sideArrow.png"
                        alt="/"
                      />
                      <div>Bulk SMS</div>
                    </li>
                    <li className="flex gap-[5%] hover:underline text-[#fff] pt-1 pb-1 font-medium md:text-[11px] lg:pt-[6%] lg:pb-[6%] lg:pl-[%] lg:text-[14px] ">
                      <img
                        className="w-[8.5px] h-[8.5px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                        src="./Images/dashboardImages/sideArrow.png"
                        alt="/"
                      />
                      <div>Recharge Card Printing</div>
                    </li>
                  </ul>
                )}

                <div
                  onClick={() => dropHandler("dropdown3")}
                  className="flex gap-[3.5px] items-center cursor-pointer justify-between"
                >
                  <div className="flex gap-1 items-center lg:gap-[11px]">
                    <img
                      className="w-[8.3px] h-[8.3px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                      src="./Images/dashboardImages/payments.png"
                      alt="icon"
                    />
                    <p>Payments</p>
                  </div>
                  {!dropDownOpen.dropdown3 ? (
                    <img
                      className="h-[8.3px] w-[8.3px] lg:w-[24px] lg:h-[24px]"
                      src="./Images/dashboardImages/arrow-down.png"
                      alt="dropdown"
                    />
                  ) : (
                    <img
                      className="h-[8.3px] w-[8.3px] lg:w-[24px] lg:h-[24px]"
                      src="./Images/dashboardImages/arrow-up.png"
                      alt="dropdown"
                    />
                  )}
                </div>
                {dropDownOpen.dropdown3 && (
                  <ul className="rounded-[2.5px]  bg-[#f2faff19] w-[100px] md:top-[42%] md:w-[100%] lg:rounded-[6px] lg:top-[41.5%] lg:w-[220px]">
                    <Link to="/wallet">
                      <li className="flex gap-[5%] hover:underline text-[#fff] pt-1 pb-1 font-medium md:text-[11px] lg:pt-[6%] lg:pb-[6%] lg:pl-[%] lg:text-[14px] ">
                        <img
                          className="w-[8.5px] h-[8.5px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                          src="./Images/dashboardImages/sideArrow.png"
                          alt="/"
                        />
                        <div>Wallets</div>
                      </li>
                    </Link>
                    <Link to="/virtual-account">
                      {" "}
                      <li className="flex gap-[5%] hover:underline text-[#fff] pt-1 pb-1 font-medium md:text-[11px] lg:pt-[6%] lg:pb-[6%] lg:pl-[%] lg:text-[14px] ">
                        <img
                          className="w-[8.5px] h-[8.5px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                          src="./Images/dashboardImages/sideArrow.png"
                          alt="/"
                        />
                        <div>Virtual Accounts</div>
                      </li>
                    </Link>

                    <Link to="/money-transfer">
                      <li className="flex gap-[5%] hover:underline text-[#fff] pt-1 pb-1 font-medium md:text-[11px] lg:pt-[6%] lg:pb-[6%] lg:pl-[%] lg:text-[14px] ">
                        <img
                          className="w-[8.5px] h-[8.5px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                          src="./Images/dashboardImages/sideArrow.png"
                          alt="/"
                        />
                        <div>Money Transfer</div>
                      </li>
                    </Link>

                    <Link to="/CardPayment">
                      <li className="flex gap-[5%] hover:underline text-[#fff] pt-1 pb-1 font-medium md:text-[11px] lg:pt-[6%] lg:pb-[6%] lg:pl-[%] lg:text-[14px] ">
                        <img
                          className="w-[8.5px] h-[8.5px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                          src="./Images/dashboardImages/sideArrow.png"
                          alt="/"
                        />
                        <div>Card Payments</div>
                      </li>
                    </Link>
                    <Link to="/To-other-banks">
                      <li className="flex gap-[5%] hover:underline text-[#fff] pt-1 pb-1 font-medium md:text-[11.5px] lg:pt-[6%] lg:pb-[6%] lg:pl-[%] lg:text-[14px] ">
                        <img
                          className="w-[8.5px] h-[8.5px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                          src="./Images/dashboardImages/sideArrow.png"
                          alt="/"
                        />
                        <div>International Payments</div>
                      </li>
                    </Link>
                  </ul>
                )}

                <div
                  onClick={() => dropHandler("dropdown4")}
                  className="flex justify-between"
                >
                  <div className="flex items-center gap-[3.4px] cursor-pointer lg:gap-[11px]">
                    <img
                      className="w-[8.3px] h-[8.3px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                      src="./Images/dashboardImages/cardissuing.png"
                      alt="icon"
                    />
                    <p>Card Issuing</p>
                  </div>
                  {!dropDownOpen.dropdown4 ? (
                    <img
                      className="h-[8.3px] w-[8.3px] lg:w-[24px] lg:h-[24px]"
                      src="./Images/dashboardImages/arrow-down.png"
                      alt="dropdown"
                    />
                  ) : (
                    <img
                      className="h-[8.3px] w-[8.3px] lg:w-[24px] lg:h-[24px]"
                      src="./Images/dashboardImages/arrow-up.png"
                      alt="dropdown"
                    />
                  )}
                </div>
                {dropDownOpen.dropdown4 && (
                  <ul className=" mt-[px] rounded-[2.5px]  bg-[#f2faff19] w-[100px] md:top-[42%] md:w-[100%] lg:rounded-[6px] lg:top-[41.5%] lg:w-[220px]">
                    <li className="flex gap-[5%] hover:underline text-[#fff] pt-1 pb-1 font-medium md:text-[11px] lg:pt-[6%] lg:pb-[6%] lg:pl-[%] lg:text-[14px] ">
                      <img
                        className="w-[8.5px] h-[8.5px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                        src="./Images/dashboardImages/sideArrow.png"
                        alt="/"
                      />
                      <div>Virtual USD Card</div>
                    </li>
                    <li className="flex gap-[5%] hover:underline text-[#fff] pt-1 pb-1 font-medium md:text-[11px] lg:pt-[6%] lg:pb-[6%] lg:pl-[%] lg:text-[14px] ">
                      <img
                        className="w-[8.5px] h-[8.5px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                        src="./Images/dashboardImages/sideArrow.png"
                        alt="/"
                      />
                      <div>Virtual NGN Card</div>
                    </li>
                    <li className="flex gap-[5%] hover:underline text-[#fff] pt-1 pb-1 font-medium md:text-[11px] lg:pt-[6%] lg:pb-[6%] lg:pl-[%] lg:text-[14px] ">
                      <img
                        className="w-[8.5px] h-[8.5px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                        src="./Images/dashboardImages/sideArrow.png"
                        alt="/"
                      />
                      <div>Physical USD Card</div>
                    </li>
                    <li className="flex gap-[5%] hover:underline text-[#fff] pt-1 pb-1 font-medium md:text-[11px] lg:pt-[6%] lg:pb-[6%] lg:pl-[%] lg:text-[14px] ">
                      <img
                        className="w-[8.5px] h-[8.5px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                        src="./Images/dashboardImages/sideArrow.png"
                        alt="/"
                      />
                      <div>Physical NGN Card</div>
                    </li>
                  </ul>
                )}
                <div className="flex gap-[3.4px] items-center cursor-pointer lg:gap-[11px]">
                  <img
                    className="w-[8.3px] h-[8.3px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                    src="./Images/dashboardImages/digitalServices.png"
                    alt="icon"
                  />
                  <Link to="/DigitalServices">
                    <p>Digital Services</p>
                  </Link>
                </div>
                <div className="flex gap-[3.4px] items-center cursor-pointer lg:gap-[11px]">
                  <img
                    className="w-[8.3px] h-[8.3px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                    src="./Images/dashboardImages/vtuDevelopment.png"
                    alt="icon"
                  />
                  <Link to="/VTU_DEV">
                    <p>VTU Development</p>
                  </Link>
                </div>
                <div className="flex gap-[3.4px] cursor-pointer items-center lg:gap-[11px]">
                  <img
                    className="w-[8.3px] h-[8.3px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                    src="./Images/dashboardImages/businessdev.png"
                    alt="icon"
                  />
                  <Link to="/businessDev">
                    <p>Business Development</p>
                  </Link>
                </div>
              </div>
            </div>

            {/* =======FEATURES======== */}
            <div>
              <p
                className={`${styles.sidebartxt} text-[7px] lg:text-[14px] font-extrabold`}
              >
                FEATURES
              </p>

              <div
                className={`${styles.sidebartxt} flex flex-col gap-[10px] text-[8px] font-semibold my-[7%] lg:text-[13px] lg:gap-[15px]`}
              >
                <div className="flex gap-[3.4px] cursor-pointer lg:gap-[11px]">
                  <img
                    className="w-[8.3px] h-[8.3px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                    src="./Images/dashboardImages/productPricing.png"
                    alt="icon"
                  />
                  <Link to="/pricing">
                    <p>Product Pricing</p>
                  </Link>
                </div>
                <Link to ="/ProfileSettingMain"
                  onClick={() => {
                    dropHandler("dropdown5");
                    //navigate("/ProfileSettingMain");
                  }}
                  state={{
                    authenticationOpen : false,
                    verficationOpen : true,
                    profilePage : false,
                    accountUpgrade : true
                  }}
                  className="flex justify-between"
                >
                  <div className="flex gap-[3.4px] items-center cursor-pointer lg:gap-[11px]">
                    <img
                      className="w-[8.3px] h-[8.3px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                      src="./Images/dashboardImages/accountUpgrade.png"
                      alt="icon"
                    />
                    <p>Account Upgrade</p>
                  </div>
                </Link>
                <div
                  onClick={() => dropHandler("dropdown6")}
                  className="flex justify-between"
                >
                  <Link to="/My-Referral">
                    <div className="flex gap-[3.4px] items-center cursor-pointer lg:gap-[11px]">
                      <img
                        className="w-[8.3px] h-[8.3px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                        src="./Images/dashboardImages/referrals.png"
                        alt="icon"
                      />
                      <p>My Referrals</p>
                    </div>
                  </Link>
                </div>
                <Link to="/ProfileSettingMain">
                  <div className="flex gap-[3.4px] cursor-pointer lg:gap-[11px]">
                    <img
                      className="w-[8.3px] h-[8.3px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                      src="./Images/dashboardImages/profileSettings.png"
                      alt="icon"
                    />
                    <p>Profile Settings</p>
                  </div>
                </Link>

                <div>
                  <div className="flex gap-[3.4px] cursor-pointer lg:gap-[11px]">
                    <img
                      className="w-[8.3px] h-[8.3px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                      src="./Images/notifyIcon.png"
                      alt="icon"
                    />
                    <p>Notifications</p>
                  </div>
                </div>
                <div className="flex gap-[3.4px] cursor-pointer lg:gap-[11px]">
                  <img
                    className="w-[8.3px] h-[8.3px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                    src="./Images/dashboardImages/developersApi.png"
                    alt="icon"
                  />
                  <p>Develop's API </p>
                </div>
                <div className="flex gap-[3.4px] cursor-pointer lg:gap-[11px]">
                  <img
                    className="w-[8.3px] h-[8.3px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
                    src="./Images/dashboardImages/contactSupport.png"
                    alt="icon"
                  />
                  <Link to="/ContactUs">
                    <p>Contact Support</p>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
  
      {/* ===========Logout========= */}

      <div
        className={`${styles.logout} pl-[5%] mt-[%] border-t-[0.3px] ml-[%] 
        flex gap-[4%] md:mt-[%] md:border-t-[1.5px] w-[100%] h-[100%]
        py-[10%] lg:pb-[10%] `}
      >
        <img
          className="w-[11px] h-[11px] md:w-[13.75px] md:h-[13.75px] lg:w-[24px] lg:h-[24px]"
          src="/Images/dashboardImages/logout.png"
          alt="logout"
        />
        <p
          className={`${styles.logouttxt} cursor-pointer text-[7px] 
          md:text-[7px] lg:text-[14px]`}
        >
          <p className="text-[10px] LogOut lg:text-[14px] font-[500]"
           onClick={() => RemoveLocalStorageKeys()}>Logout</p>
        </p>
      </div>
    </div>
    
   

 
  );
};
